<template>
    <div>
        <div class="header">
            <h4>Admins</h4>
        </div>
        <el-form label-position="left" size="small" inline>
            <el-form-item label="User's email">
                <el-input v-model="email" placeholder="Email" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="newAdmin" v-loading="loading.admin">Make user admin</el-button>
            </el-form-item>
        </el-form>

        <Table :items="admins" :columns="columns" :actions="actions" filterProp="email" :loading="loading.admins" />

        <Dialog title="Edit Admin" :show="showEditDialog" :onClose="() => showEditDialog = false">
            <AccountForm :account="account" :afterSave="() => showEditDialog = false" />
        </Dialog>
    </div>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Table from '@/components/Table';
import Dialog from '@/components/Dialog';
import AccountForm from '@/views/Account/AccountForm';

export default {
    name: 'admins',
    data() {
        return {
            email: '',
            columns: [{label: 'Name', prop: 'first_name'}, {label: 'Email', prop: 'email'}],
            actions: [
                { name: 'Edit', type: 'default', onClick: this.edit },
                { name: 'Revoke', type: 'danger', onClick: this.revoke, requiresConfirm: true },
            ],

            account: {},
            showEditDialog: false,
        };
    },
    components: {
        Table,
        AccountForm,
        Dialog
    },
    mounted() {
        if (isEmpty(this.admins)) this.getAdmins();
    },
    computed: mapGetters(['admins', 'loading']),
    methods: {
        ...mapActions(['setUserAsAdmin', 'getAdmins']),
        edit(admin) {
            this.account = cloneDeep(admin);
            this.showEditDialog = true;
        },
        async revoke(admin) {
            try {
                await this.$api.delete(`/admins/${admin.id}`);
                this.$message.info(`${admin.email} is not an admin anymore!`);
                this.getAdmins();
            } catch (e) {
                this.$notify.error({
                    title: 'Coludn\'t revoke admin :(',
                    message: e.message,
                });
            }
        },
        async newAdmin() {
            try {
                const email = this.email || '';
                await this.setUserAsAdmin(email.trim());
                this.$message.success(`${email} is now an admin.`);
                this.getAdmins();
            } catch (e) {
                this.$message.error(`Failed making ${this.email} an admin.`);
            }
        }
    }
}
</script>
